import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRedux } from '../../../redux/hook/useRedux';
import { useSelector } from 'react-redux';
import { actionLoggoutUser, actionLoginUser } from '../../../redux/user/actions';

export const useHeader = () => {
    const { dispatch } = useRedux();
    const navigate = useNavigate();
    const { user } = useSelector(root => root.userReducer);

    const [openHeader, setOpenHeader] = useState(false);
    const toggleOpenHeader = () => setOpenHeader(!openHeader);

    const handleLoginClick = () => {
    }

    const handleLogoutClick = () => {
        dispatch(actionLoggoutUser())
    }

    return {
        openHeader,
        toggleOpenHeader,
        navigate,
        user,
        handleLoginClick,
        handleLogoutClick
    }
}